import React, { useCallback, useEffect } from "react"
import { StyledComponent } from "@rogue_4/types"
import anime from "animejs"
import classNames from "classnames"

import { useDivRef } from "../../../hooks/useDivRef"
import { useGameModalStore } from "../store"

import styles from "./index.module.less"

const EffectModal: StyledComponent = ({ className, style }) => {
    const maskRef = useDivRef()
    const callWhiteMask = useCallback(() => {
        if (!maskRef.current) return
        maskRef.current.style.pointerEvents = "all"
        anime
            .timeline()
            .add({
                targets: maskRef.current,
                duration: 1000,
                easing: "easeInCubic",
                opacity: [0, 1],
                begin: () => {
                    maskRef.current!.style.maskImage = `radial-gradient(ellipse at center, white 0, white 0, transparent 0)`
                },
                update(anim) {
                    maskRef.current!.style.maskImage = `radial-gradient(ellipse at center, white 0, white ${anim.progress.toFixed(2)}%, transparent ${(1.5 * anim.progress).toFixed(2)}%)`
                },
            })
            .add(
                {
                    targets: maskRef.current,
                    easing: "easeOutCubic",
                    duration: 500,
                    opacity: 0,
                    complete: () => {
                        maskRef.current!.style.pointerEvents = "none"
                    },
                },
                2000
            )
    }, [maskRef])
    useEffect(() => {
        useGameModalStore.setState({
            callEffectModal: (key: string) => {
                if (key === "whiteMask") {
                    callWhiteMask()
                }
            },
        })
    }, [callWhiteMask])

    return (
        <div
            className={classNames(styles.effectModal, className)}
            style={style}
        >
            <div className={styles.whiteMask} ref={maskRef}></div>
        </div>
    )
}

export default EffectModal
